var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from './svgIcon';

export default (function (path) {
  var customProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return pure(function (props) {
    return React.createElement(
      SvgIcon,
      _extends({}, props, customProps),
      path
    );
  });
});